<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Country Third ID"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`15- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Country code"
            @input="updateThirdIdFiltered()"
            v-model="countryFilter"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-switch
            v-model="show_deleted"
            label="Show deleted"
            @change="syncFiltered()"
          ></v-switch>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Code</th>
              <th scope="col">ThirdIdCountry</th>
              <th scope="col">Begin</th>
              <th scope="col">End</th>
              <th scope="col">Currency</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="country in countriesFiltered" :key="country.id">
              <td>{{ country.id }}</td>
              <td>{{ country.name }}</td>
              <td>{{ country.code }}</td>
              <td>{{ country.thirdIdCountry }}</td>
              <td>{{ country.begin }}</td>
              <td>{{ country.end }}</td>
              <td v-if="!isCurrencyNull(country)">
                {{ country.currency.currencyCode }}
              </td>
              <td v-if="isCurrencyNull(country)">No Currency found</td>
              <td>
                <router-link
                  v-if="isAdminUser"
                  class="btn btn-edit"
                  v-bind:to="{ path: 'editCountry', query: { id: country.id } }"
                >
                  <v-icon>mdi-pencil</v-icon>
                  <span class="editspan">Edit</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";

export default {
  name: "Countries",
  data() {
    return {
      countries: [],
      countriesFiltered: [],
      id: "15",
      sub_id: null,
      third_id_filtered: "15--",
      show_deleted: false,
      countryFilter: null,
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/countries`)
      .then((response) => {
        this.countries = response.data;
        this.syncFiltered();
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id == null ? "" : this.sub_id;
      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
      this.syncFiltered();
    },

    syncFiltered: function () {
      this.countriesFiltered = new Array();
      this.countries.forEach((country) => {
        if (this.isCountryFiltered(country) && this.isDeleted(country)) {
          this.countriesFiltered.push(country);
        }
      });
    },

    isDeleted: function (country) {
      return this.show_deleted || (!this.show_deleted && country.end == null);
    },

    isCountryFiltered: function (country) {
      return (
        (this.third_id_filtered === "15--" ||
          this.third_id_filtered === country.thirdIdCountry) &&
        (this.countryFilter === null ||
          this.countryFilter === "" ||
          country.code == this.countryFilter)
      );
    },
    isCurrencyNull: function (country) {
      return country.currency === null;
    }
  },
};
</script>





// WEBPACK FOOTER //
// src/components/countries/Countries.vue